import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { TempPasswordStatusResponseType } from './types'
import { useQuery } from '@tanstack/react-query'

const fetchTempPasswordStatus = async (userId: string) => {
  const response = await httpClientPrivate.get<TempPasswordStatusResponseType>(
    `${config.restUrl}/v1/backoffice/user/${userId}/status-temp-password`,
  )

  return response.data
}

const useTempPasswordStatus = (query: { userId: string }) => {
  const queryKey = ['useTempPasswordStatus', query]
  const queryFn = async () => fetchTempPasswordStatus(query.userId)
  const queryResult = useQuery({ queryFn, queryKey, enabled: !!query.userId })
  return { ...queryResult }
}

export { fetchTempPasswordStatus, useTempPasswordStatus }
